export default __webpack_public_path__ + "static/media/vegW2.15e3e1b4.png";